<template>
    <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M40.147 19.7057C42.2385 18.7824 44.1414 17.4805 45.7598 15.8657C46.0243 15.5615 46.1642 15.1687 46.1515 14.7659C46.1389 14.363 45.9747 13.9797 45.6917 13.6927C45.4087 13.4057 45.0278 13.236 44.6252 13.2177C44.2225 13.1993 43.8278 13.3336 43.5198 13.5937C40.6175 16.4893 36.6852 18.1155 32.5854 18.1155C28.4857 18.1155 24.5534 16.4893 21.651 13.5937C21.3506 13.2933 20.9431 13.1245 20.5182 13.1245C20.0934 13.1245 19.6859 13.2933 19.3854 13.5937C19.085 13.8942 18.9162 14.3017 18.9162 14.7265C18.9162 15.1514 19.085 15.5589 19.3854 15.8593C21.002 17.4735 22.9026 18.7753 24.9918 19.6993V46.4897C24.9879 46.5537 24.9879 46.6178 24.9918 46.6817C22.8935 47.6031 20.984 48.905 19.3598 50.5217C19.0594 50.8222 18.8906 51.2296 18.8906 51.6545C18.8906 52.0794 19.0594 52.4869 19.3598 52.7873C19.6603 53.0878 20.0678 53.2566 20.4926 53.2566C20.9175 53.2566 21.325 53.0878 21.6254 52.7873C23.0639 51.3506 24.7712 50.2112 26.65 49.4342C28.5288 48.6573 30.5422 48.258 32.5753 48.2592C34.6084 48.2604 36.6213 48.662 38.4992 49.4412C40.3771 50.2203 42.0831 51.3617 43.5198 52.8001C43.828 53.0312 44.2091 53.1434 44.5933 53.1161C44.9774 53.0888 45.3389 52.9238 45.6112 52.6515C45.8836 52.3792 46.0485 52.0177 46.0758 51.6336C46.1031 51.2494 45.9909 50.8682 45.7598 50.5601C44.1357 48.9434 42.2261 47.6415 40.1278 46.7201C40.1318 46.6562 40.1318 46.5921 40.1278 46.5281L40.147 19.7057ZM36.947 45.6001C34.0631 44.9084 31.0565 44.9084 28.1726 45.6001V20.7937C31.0563 21.4872 34.0633 21.4872 36.947 20.7937V45.6001Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "GeminiIcon",
});
</script>
